import { type AxisValue, formatAxisValues } from '@ifixit/helpers';
import { cn } from '@ifixit/ui/lib/utils';

/**
 * Per-axis store-offer discriminator (issue #55186) shared by all search
 * surfaces. Renders the axis of variation as a muted suffix of the product
 * title -- e.g. "Opening Tool - Pack of 5 / Sapphire Crystal" -- so a card's
 * variant reads on the title line rather than a separate row. PHP emits the
 * axes in display order (split axes lead) so the FE just renders. Returns null
 * on an empty/suppressed set so callers can drop it into a title unconditionally.
 */
export interface AxisValueSuffixProps {
   axisValues?: AxisValue[] | null;
   className?: string;
}

export function AxisValueSuffix({ axisValues, className }: AxisValueSuffixProps) {
   const label = formatAxisValues(axisValues);
   if (label === null) {
      return null;
   }

   return (
      <span className={cn('font-normal text-gray-700', className)} data-testid="axis-values">
         {' - '}
         {label}
      </span>
   );
}
